export const ASSIGNABLE_ROLE_NAMES = {
  ADMIN: "admin",
  EMPLOYEE: "employee",
};
